import CustomButton from "@/components/CustomButton";
import { useAppDispatch } from "@/hooks/useAppDispatch";
import { useAppSelector } from "@/hooks/useAppSelector";
import { uqActions } from "@/redux/uq/uq-slice";
import { UPSettings } from "@/types/types";
import ScrollView from "devextreme/ui/scroll_view";

export default function ColsButtons() {
  const { gridSet, settings } = useAppSelector((state) => state.uq);
  const { household } = useAppSelector((state) => state.household);
  const dispatch = useAppDispatch();

  async function toggleSettingAndRefresh(
    value: keyof UPSettings | "ss2" | "ss1" | "age1" | "age2"
  ) {
    switch (value) {
      case "ss2":
        dispatch(
          uqActions.setSettings({
            ...settings,
            person2: {
              ...settings.person2,
              showSS: !settings.person2?.showSS,
            },
          })
        );
        break;
      case "ss1":
        dispatch(
          uqActions.setSettings({
            ...settings,
            person1: {
              ...settings.person1,
              showSS: !settings.person1?.showSS,
            },
          })
        );
        break;
      case "age1":
        dispatch(
          uqActions.setSettings({
            ...settings,
            person1: {
              ...settings.person1,
              showAge: !settings.person1?.showAge,
            },
          })
        );
        break;
      case "age2":
        dispatch(
          uqActions.setSettings({
            ...settings,
            person2: {
              ...settings.person2,
              showAge: !settings.person2?.showAge,
            },
          })
        );
        break;
      default:
        dispatch(
          uqActions.setSettings({
            ...settings,
            [value]: !settings[value],
          })
        );
    }

    dispatch(uqActions.setIsModified(true));
    if (gridSet) {
      const sv = document.getElementById("household-scrollview") as HTMLElement;
      const scroll = ScrollView.getInstance(sv) as any;

      setTimeout(() => {
        dispatch(uqActions.setReload(false));
        setTimeout(() => {
          if (scroll) {
            const h = scroll.scrollHeight();
            scroll.scrollTo(h);
          }
        }, 100);
      }, 300);
    }
  }

  const primaryContactDeceased = household?.primaryContact?.isDeceased;
  const secondaryContactDeceased = household?.secondaryContact?.isDeceased;

  const isAnyClientDeceased = secondaryContactDeceased || primaryContactDeceased;

  return (
    <div
      className={`flex flex-1 flex-wrap items-center gap-8 print:hidden ${isAnyClientDeceased ? "w-full" : "w-1/2"}`}
    >
      <CustomButton
        onClickHandler={() => toggleSettingAndRefresh("showRor")}
        text={`${settings?.showRor ? "Hide" : "Show"} RoR Percentage`}
        className="min-w-fit-content"
      />

      {!household?.isSingle && (
        <CustomButton
          onClickHandler={() => toggleSettingAndRefresh("showSS")}
          text={`${settings?.showSS ? "Hide" : "Show"} Social Security ${
            household?.isSingle ? "Column" : "Columns"
          }`}
          className="min-w-fit-content"
        />
      )}

      {primaryContactDeceased ? (
        <CustomButton
          text={`${settings.person1.showSS ? "Hide" : "Show"} Social Security of ${
            household.primaryContact?.preferredFirstName
          }`}
          onClickHandler={() => toggleSettingAndRefresh("ss1")}
          className="min-w-fit-content"
        />
      ) : null}

      {secondaryContactDeceased ? (
        <CustomButton
          text={`${settings?.person2?.showSS ? "Hide" : "Show"} Social Security of ${
            household.secondaryContact?.preferredFirstName
          }`}
          onClickHandler={() => toggleSettingAndRefresh("ss2")}
          className="min-w-fit-content"
        />
      ) : null}

      {primaryContactDeceased ? (
        <CustomButton
          text={`${settings?.person1.showAge ? "Hide" : "Show"} Age Column of ${
            household.primaryContact?.preferredFirstName
          }`}
          onClickHandler={() => toggleSettingAndRefresh("age1")}
          className="min-w-fit-content"
        />
      ) : null}

      {secondaryContactDeceased ? (
        <CustomButton
          text={`${settings?.person2?.showAge ? "Hide" : "Show"} Age Column of ${
            household.secondaryContact?.preferredFirstName
          }`}
          onClickHandler={() => toggleSettingAndRefresh("age2")}
          className="min-w-fit-content"
        />
      ) : null}
    </div>
  );
}
